import EDC from '../../../../shared/globals';
import CursorManager from '../../../../shared/cursor-manager';

EDC.Games.SynonymRolls.Scenes.Intro = function () {};

EDC.Games.SynonymRolls.Scenes.Intro.prototype.create = function () {
  const intro = this.add.sprite(0, 0, 'intro-background').setOrigin(0).setInteractive();
  const shop = this.add.sprite(973, 515, 'shop').setInteractive();
  const image = this.add.sprite(950, 170, 'intro-enter').setInteractive();
  const cursorManager = new CursorManager(this.game.canvas);
  cursorManager.setDefaultDraggableEvents(shop);
  cursorManager.setDefaultDraggableEvents(image);
  this.drawAttention(image);

  image.on('pointerdown', function () {
    intro.destroy();
    shop.destroy();
    image.destroy();
    this.scene.start('main');
  }, this);

  shop.on('pointerdown', function () {
    intro.destroy();
    shop.destroy();
    image.destroy();
    this.scene.start('main');
  }, this);
};

EDC.Games.SynonymRolls.Scenes.Intro.prototype.drawAttention = function (image) {
  this.tweens.add({
    targets: image,
    scaleX: 1.2,
    scaleY: 1.2,
    ease: 'Linear',
    duration: 500,
    yoyo: true,
    repeat: -1,
  });
};

export default EDC.Games.SynonymRolls.Scenes.Intro;
